"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_helpers_1 = require("@flowio/browser-helpers");
function loadGoogleAnalyticsGtag(measurementId) {
    window.dataLayer = window.dataLayer || [];
    var gtag = window.gtag = function () {
        dataLayer.push(arguments);
    };
    gtag('js', new Date());
    browser_helpers_1.loadScript("https://www.googletagmanager.com/gtag/js?id=" + measurementId, {
        async: true,
    });
}
exports.default = loadGoogleAnalyticsGtag;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/gtag/loadGoogleAnalyticsGtag.js
// module id = 313
// module chunks = 0 1